import { Link } from "react-router-dom";
import { ArrowUpRight, GraduationCap, LibraryBig, Briefcase, Languages } from "lucide-react";
import { motion } from "framer-motion";
import { fadeUp } from "../lib/motion";

const ICONS = { GraduationCap, LibraryBig, Briefcase, Languages };

export const PercorsoCard = ({ percorso, index }) => {
  const Icon = ICONS[percorso.icon] || GraduationCap;
  return (
    <motion.div variants={fadeUp}>
      <Link
        to={percorso.slug}
        data-testid={`card-percorso-${percorso.slug.replace("/", "")}`}
        className="group relative flex flex-col h-full bg-white rounded-2xl border border-slate-200 p-7 lg:p-8 transition-all duration-300 hover:-translate-y-1.5 hover:border-azure hover:shadow-[0_28px_60px_-30px_rgba(8,42,89,0.35)]"
      >
        <div className="flex items-start justify-between mb-8">
          <span className="text-xs font-bold tracking-[0.2em] text-slate-400">
            {percorso.numero}
          </span>
          <span className="inline-flex items-center justify-center w-11 h-11 rounded-xl bg-azure-light text-azure transition-colors duration-300 group-hover:bg-azure group-hover:text-white">
            <Icon size={21} strokeWidth={1.8} />
          </span>
        </div>
        <h3 className="text-xl font-bold tracking-tight text-navy leading-snug">
          {percorso.titolo}
        </h3>
        <p className="mt-3 text-sm text-slate-600 leading-relaxed flex-1">
          {percorso.descrizione}
        </p>
        <span className="mt-7 inline-flex items-center gap-2 text-sm font-bold text-azure">
          Scopri di più
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </span>
      </Link>
    </motion.div>
  );
};
